module.exports = __webpack_public_path__ + "static/media/11-camping_08_21_2020.48be33d2.jpg";